import React from 'react';
import { ArrowRight } from 'lucide-react';
import { images } from '../../data/blackout';
import { useBundle } from '../../contexts/BundleContext';
import { goToCheckout } from '../../utils/checkout';
import { formatPrice } from '../../utils/currency';
import { scrollToSection } from '../../utils/scroll';
export function FinalCTA() {
  const {
    selected
  } = useBundle();
  return <section className="relative overflow-hidden border-t-2 border-bone/80 bg-obsidian" data-id="element-170" data-mp="3nya3l68gj7vk">
      <img src={images.finalCity} alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 h-full w-full object-cover object-[80%_center]" data-id="element-171" data-mp="3nvxnyzq699lo" />
      <div className="absolute inset-0 bg-obsidian/50" aria-hidden="true" data-id="element-172" data-mp="3ezewzt1i3vrq" />
      <div className="halftone absolute inset-0" aria-hidden="true" data-id="element-173" data-mp="39y9702z86mlw" />

      <div className="relative mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-36" data-id="element-174" data-mp="23jgih9nk0hj4">
        <div className="max-w-2xl" data-id="element-175" data-mp="1yist0sez48r0">
          <h2 className="font-display text-6xl uppercase leading-[0.9] text-bone md:text-8xl" data-id="element-176" data-mp="1yhra61rpuhyq">
            Your chapter starts after dark.
          </h2>
          <p className="mt-6 rotate-[-3deg] font-script text-3xl text-bone/85" data-id="element-177" data-mp="2qjbdrr2dwxwk">
            Same world. Different you.
          </p>

          <button type="button" onClick={() => goToCheckout(selected)} className="group mt-10 inline-flex h-16 w-full max-w-md items-center justify-center gap-3 bg-bone px-8 text-[13px] font-semibold uppercase tracking-[0.2em] text-obsidian transition-[background-color,transform] duration-150 ease-out hover:bg-white active:scale-[0.98]" data-id="element-178" data-mp="2ci8q59vqrfjj">
            {selected.cta}
            <ArrowRight className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-179" data-mp="1tudje9yjr1zx" />
          </button>

          <p className="mt-4 text-sm uppercase tracking-[0.1em] text-bone/80" data-id="element-180" data-mp="1juwbdlvtoc0s">
            {selected.name} · {selected.deal} · {formatPrice(selected.price)}
            {selected.shipping === 'free' ? ' · Free U.S. shipping' : ' + shipping'}
          </p>
          <button type="button" onClick={() => scrollToSection('bundles')} className="mt-2 text-sm text-bone underline decoration-steel underline-offset-4 transition-colors duration-150 hover:decoration-bone" data-id="element-181" data-mp="10xkq9ysvkz77">
            Change chapter
          </button>
        </div>
      </div>
    </section>;
}